<div class="min-h-screen flex flex-col bg-background text-color-primary">
    <!-- Navbar -->
    <app-header></app-header>

    <!-- Main Content -->
    <main class="flex-1 p-4 container mx-auto fade-in">
        <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <footer class="border-t border-gray-100 bg-white/50 py-8 mt-auto">
        <div class="container mx-auto px-4 text-center text-sm text-gray-500">
            <p>© 2026 KronoFlow. Todos los derechos reservados.</p>
        </div>
    </footer>
</div>